import React from 'react';
import './logo.css';  

const Logo = () => {
  return (
    <div className="trusted-companies">
      <h3>Dipercaya oleh Perusahaan Lokal dan Global</h3>
      <div className="logos">
        <img src="bajawa.png" alt="Bajawa" />
        <img src="alsozo.png" alt="Alsozo" />
        <img src="arfia.png" alt="Arfia" />
        <img src="fif.png" alt="FIF Global" />
        <img src="igp.png" alt="IGP" />
        <img src="itsri.png" alt="Itsiri" />
        <img src="khasanah.png" alt="Khasanah" />
        <img src="toyobo.png" alt="Toyobo" />
        <img src="global.png" alt="Logo 9" />
        <img src="daco.png" alt="Logo 10" />
        <img src="otopia.png" alt="Logo 11" />
        <img src="adya.png" alt="Logo 12" />
      </div>
      <div className="logos">
        <img src="bajawa.png" alt="Bajawa" />
        <img src="alsozo.png" alt="Alsozo" />
        <img src="arfia.png" alt="Arfia" />
        <img src="fif.png" alt="FIF Global" />
        <img src="igp.png" alt="IGP" />
        <img src="itsri.png" alt="Itsiri" />
        <img src="khasanah.png" alt="Khasanah" />
        <img src="toyobo.png" alt="Toyobo" />
        <img src="global.png" alt="Logo 9" />
        <img src="daco.png" alt="Logo 10" />
        <img src="otopia.png" alt="Logo 11" />
        <img src="adya.png" alt="Logo 12" />
      </div>
    </div>
  );
};

export default Logo;